import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';
import { BrowserTracing } from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from '@env/environment';
import { SentryConstant, ConfigConstant } from '@shared/constants';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://e09d30754dd0483b920e3ba01f18bd8a@o4504882214928384.ingest.sentry.io/4504887881170944',
  enabled: environment.production,
  // App version — lets you see which release each event/replay came from.
  release: `${window.location.hostname}@${ConfigConstant.VERSION}`,
  enableTracing: environment.production,
  ignoreErrors: SentryConstant.IgnoredErrors,
  denyUrls: SentryConstant.DeniedUrls,
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: ['localhost', environment.base_url, environment.socket_url],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    Sentry.replayIntegration({
      // Redact sensitive content: mask all text and block all media by default.
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: environment.production ? 1.0 : 0.1,
  
  // Session Replay
  // Percentage of all sessions to record (0.1 = 10%).
  replaysSessionSampleRate: environment.production ? 1.0 : 0.1,
  // Percentage of sessions with an error to record (1.0 = 100%).
  replaysOnErrorSampleRate: environment.production ? 1.0 : 0.1,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
